<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->

      <b-link class="brand-logo auth-page">
        <b-card class="shadow-none">
          <logo />
        </b-card>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 overflow-hidden bg-white"
        :style="`background-image: url(${imgUrl}); background-position: center; background-size: cover;`"
      />
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <network-status-banner class="auth-login-network-status mb-2" />
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('shared.login') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('login.welcome') }} {{ companyName }}
          </b-card-text>

          <div v-if="isTwoFactorAuthenticationInProgress">
            <!-- authCode -->
            <b-form-group
              :label="$t('shared.auth-code')"
              label-for="login-auth-code"
            >
              <b-form-input
                id="login-auth-code"
                v-model="authCode"
                name="login-auth-code"
                type="text"
                placeholder="000000"
                maxlength="6"
                autocomplete="off"
                @input="verifyAuthCode"
              />
            </b-form-group>

          </div>

          <div v-else>
            <!-- form -->
            <validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
              >
                <!-- email -->
                <b-form-group
                  :label="$t('shared.username')"
                  label-for="login-username"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('shared.username')"
                    :rules="{ required: true, min: 3, max: 50, regex: /^[a-z0-9_-]+$/ }"
                  >
                    <b-form-input
                      id="login-username"
                      v-model="username"
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      :placeholder="$t('shared.username')"
                      autocomplete="username"
                      @input="handleUsernameInput"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">{{ $t('shared.password') }}</label>
                  <!--                  <b-link :to="{name:'auth-forgot-password-v2'}">-->
                  <!--                    <small>Forgot Password?</small>-->
                  <!--                  </b-link>-->
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('shared.password')"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="loading"
                  @click="login"
                >
                  <b-spinner
                    v-show="loading"
                    small
                  />
                  {{ $t('shared.login') }}
                </b-button>
              </b-form>
            </validation-observer>
          </div>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Logo from '@core-override/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BForm, BButton, BSpinner,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import BeamsClient from '@/libs/beams'
import { waitForLocaleMessages } from '@/libs/i18n'
import { sanitizeUsername } from '@/helpers/helpers'
import { consumePendingLoginReload, consumeStoredAuthRedirectToast, reloadCurrentPage } from '@/helpers/authSession'
import { withTenantKey } from '@/libs/storageKeys'
import NetworkStatusBanner from '@/layouts/components/NetworkStatusBanner.vue'
// import store from '@/store/store'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BForm,
    BButton,
    BSpinner,
    Logo,
    ValidationProvider,
    ValidationObserver,
    NetworkStatusBanner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      authCode: '',
      loading: true,
      sideImg: require('@/assets/images/pages/login/bg3.png'),
      required,
    }
  },
  computed: {
    companyName() {
      return this.$store.state.appConfig.organization.info.shortName
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      // if (store.state.appConfig.layout.skin === 'dark') {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
      //   return this.sideImg
      // }
      return this.sideImg
    },
    isTwoFactorAuthenticationInProgress() {
      return this.$store.getters['auth/isTwoFactorAuthenticationInProgress']
    },
  },
  beforeMount() {
    if (this.handlePendingLoginReload()) {
      return
    }
    this.showPendingRedirectToast()
    if (this.isUserLoggedIn()) {
      return
    }
    BeamsClient.clearAllState().catch(() => {})
  },
  methods: {
    handlePendingLoginReload() {
      if (!consumePendingLoginReload()) {
        return false
      }

      reloadCurrentPage()
      return true
    },
    async showPendingRedirectToast() {
      const messageKey = consumeStoredAuthRedirectToast()
      if (messageKey) {
        await waitForLocaleMessages()
        const notifyMethod = messageKey === 'auth.logout-success' ? 'success' : 'warning'
        window.toast.notify[notifyMethod](this.$t(messageKey))
      }
    },
    getLoginErrorMessage(error) {
      const message = error?.response?.data?.message
        || error?.data?.message
        || error?.response?.message
        || error?.message

      return message || this.$t('login.wrong_data')
    },
    isTwoFactorSessionExpiredError(error) {
      const message = error?.response?.data?.message
        || error?.data?.message
        || error?.message

      return message === 'Full authentication is required to access this resource.'
    },
    handleTwoFactorSessionExpired() {
      this.authCode = ''
      this.password = ''
      this.loading = false
      this.$store.commit('auth/SET_2FA_IN_PROGRESS', false)
      window.toast.notify.danger(this.$t('login.two-factor-session-expired'))
    },
    isUserLoggedIn() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$router.push(this.getDefaultRouteForUser())
        return true
      }
      this.loading = false
      return false
    },
    async login() {
      if (this.isUserLoggedIn()) {
        return
      }

      this.loading = true
      this.username = sanitizeUsername(this.username)
      const valid = await this.$refs.loginValidation.validate()
      if (!valid) {
        this.loading = false
        return
      }

      await this.requestNotificationPermission()

      const payload = {
        userDetails: {
          username: this.username,
          password: this.password,
        },
      }

      try {
        const res = await this.$store.dispatch('auth/login', payload)
        if (res.data.token) {
          this.getUserInfo()
        } else {
          this.loading = false
        }
      } catch (err) {
        this.loading = false
        window.toast.notify.danger(this.getLoginErrorMessage(err))
      }
    },
    handleUsernameInput(value) {
      this.username = sanitizeUsername(value)
    },
    async verifyAuthCode() {
      if (this.authCode.length !== 6) {
        return
      }

      await this.requestNotificationPermission()

      const payload = {
        authCode: this.authCode,
        addDeviceToTrusted: true,
      }

      try {
        const res = await this.$store.dispatch('auth/twoFactorCheck', payload)
        if (res.data.token) {
          this.getUserInfo()
        }
        if (res.data.login === 'failed') {
          window.toast.notify.danger(this.$t(res.data.message ?? 'login.wrong_data'))
        }
      } catch (err) {
        if (this.isTwoFactorSessionExpiredError(err)) {
          this.handleTwoFactorSessionExpired()
          return
        }

        this.loading = false
        window.toast.notify.danger(this.getLoginErrorMessage(err))
      }
    },
    async requestNotificationPermission() {
      try {
        await BeamsClient.requestPermissionIfNeeded()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('[Beams] Notification permission request skipped:', err?.message || err)
      }
    },
    getUserInfo() {
      Promise.all([
        this.$store.dispatch('auth/fetchUserInfo'),
        this.$store.dispatch('auth/fetchUserTeam'),
      ])
        .then(() => {
          const prevRoute = localStorage.getItem('previousPath')
          if (prevRoute) {
            localStorage.removeItem('previousPath')
            this.$router.push(prevRoute)
          } else {
            this.$router.push(this.getDefaultRouteForUser())
          }
        })
        .catch(err => {
          this.loading = false
          window.toast.notify.danger(this.getLoginErrorMessage(err))
        })
    },
    getDefaultRouteForUser() {
      const rolesFromStore = this.$store.getters['auth/getUserRoles'] || []
      const roles = rolesFromStore.length > 0 ? rolesFromStore : this.getUserRolesFromStorage()
      if (roles.includes('ROLE_EXTERNAL_REQUESTER') || roles.includes('ROLE_EXTERNAL_PARTNER_ADMIN')) {
        return { name: 'partner-order-request-list' }
      }

      return { name: 'dashboard' }
    },
    getUserRolesFromStorage() {
      try {
        const userInfo = JSON.parse(localStorage.getItem(withTenantKey('userInfo')) || '{}')
        return Array.isArray(userInfo.roles) ? userInfo.roles : []
      } catch (err) {
        return []
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.auth-login-network-status.network-status-banner {
  margin-top: 0;
}
</style>
